<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      d="M8.5 3.5C8.5 2.94772 8.94772 2.5 9.5 2.5H14.5C15.0523 2.5 15.5 2.94772 15.5 3.5C15.5 4.05228 15.0523 4.5 14.5 4.5H9.5C8.94772 4.5 8.5 4.05228 8.5 3.5Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M19 7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H5V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V7ZM9.5 9.2C9.94183 9.2 10.3 9.55817 10.3 10V17C10.3 17.4418 9.94183 17.8 9.5 17.8C9.05817 17.8 8.7 17.4418 8.7 17V10C8.7 9.55817 9.05817 9.2 9.5 9.2ZM15.3 10C15.3 9.55817 14.9418 9.2 14.5 9.2C14.0582 9.2 13.7 9.55817 13.7 10V17C13.7 17.4418 14.0582 17.8 14.5 17.8C14.9418 17.8 15.3 17.4418 15.3 17V10Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
